import { TFunction } from 'i18next';
import React from 'react';
import styled from 'styled-components';

import { WinData } from '../../types';

enum PercColors {
  high = '#28a745',
  medium = '#ED7014',
  low = '#dc3545',
  noVal = 'lightgrey',
}

const IntervalDiv = styled.div`
  margin-bottom: 5px;
  font-size: 18px;
  color: #1b1b1b;
  font-weight: bold;
`;

const PercentageDiv = styled.div`
  margin-bottom: 5px;
  font-size: 20px;
  font-weight: bold;
  color: ${(props: { val?: number; isWinRate?: boolean }) => {
    const styleForRate =
      props.val < 50
        ? props.val < 20
          ? PercColors.low
          : PercColors.medium
        : PercColors.high;
    const styleForPercentage = props.val < 0 ? PercColors.low : PercColors.high;
    const colorStyle = props.isWinRate ? styleForRate : styleForPercentage;
    return props.val === null ? PercColors.noVal : colorStyle;
  }};
`;

export const RANKS = ['E', 'D', 'C', 'B', 'A', 'S'];
const intervals = ['1d', '3d', '5d', '1m', '3m', '1y'];
export const notations = {
  0: 'E',
  1: 'D',
  2: 'C',
  3: 'B',
  4: 'A',
  5: 'S',
};

export const WinRateOrPercentageColumn = ({
  t,
  ranks,
  rawDataKey,
}: {
  t: TFunction;
  ranks: WinData;
  rawDataKey: string;
}) => {
  return ranks && ranks[rawDataKey]
    ? ranks[rawDataKey].map((val, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <IntervalDiv>{t(intervals[index])}</IntervalDiv>
          <PercentageDiv
            val={val}
            isWinRate={
              rawDataKey === 'myRatesRaw' || rawDataKey === 'influencerRatesRaw'
            }
          >
            {val && Math.round(val * 10) / 10}
            {val || val === 0 ? '%' : '-'}
          </PercentageDiv>
        </div>
      ))
    : null;
};

export const generateRadarChartData = (
  t: TFunction,
  winRateData: number[],
  winPercentageData: number[]
): Record<string, unknown> => {
  return {
    labels: intervals.map(interval => t(interval)),
    datasets: [
      {
        label: t('win-rate'),
        data: winRateData,
        backgroundColor: 'rgba(18,14,241,0.2)',
        borderColor: '#120ef1',
        borderWidth: 1,
      },
      {
        label: t('earning-%'),
        data: winPercentageData,
        backgroundColor: 'rgba(18,158,0, 0.2)',
        borderColor: '#129e00',
        borderWidth: 1,
      },
    ],
  };
};
